<div>
    <button class="btn btn-secondary"
            type="button"
            [attr.title]="hasFilters ? hasFiltersText : hasNoFiltersText"
            [attr.aria-label]="hasFilters ? hasFiltersText : hasNoFiltersText"
            (click)="showQueryDialog()"
            [class.border]="hasFilters">
        <i class="fa-solid fa-filter"></i>
    </button>
</div>